<template>
  <div class="md-snapshot-panels">
    <div class="md-snapshot-panel">
      <div class="md-panel-header">Month To Date</div>
      <div class="grid">
        <template v-if="monthDisplayCards.length">
          <div
            v-for="card in monthDisplayCards"
            :key="`month-${card.title}`"
            class="col-12 sm:col-6 xl:col-3"
          >
            <StatCard
              :title="card.title"
              :content-str="card.value"
              card-type="minimal"
              :loader="card.loader"
            />
          </div>
        </template>
        <div v-else class="col-12">
          <div class="md-empty">
            {{
              monthLoading ? "Loading metrics..." : "No month-to-date metrics."
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="md-snapshot-panel">
      <div class="md-panel-header">Year To Date</div>
      <div class="grid">
        <template v-if="yearDisplayCards.length">
          <div
            v-for="card in yearDisplayCards"
            :key="`year-${card.title}`"
            class="col-12 sm:col-6 xl:col-3"
          >
            <StatCard
              :title="card.title"
              :content-str="card.value"
              card-type="minimal"
              :loader="card.loader"
            />
          </div>
        </template>
        <div v-else class="col-12">
          <div class="md-empty">
            {{
              yearLoading ? "Loading metrics..." : "No year-to-date metrics."
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import StatCard from "@/components/AdminNewDashboard/AdminNewDashboardComponents/StatCard.vue";

const PLACEHOLDER_COUNT = 4;

const props = defineProps({
  monthCards: {
    type: Array,
    default: () => [],
  },
  yearCards: {
    type: Array,
    default: () => [],
  },
  monthLoading: {
    type: Boolean,
    default: false,
  },
  yearLoading: {
    type: Boolean,
    default: false,
  },
  monthPlaceholderLabels: {
    type: Array,
    default: () => [],
  },
  yearPlaceholderLabels: {
    type: Array,
    default: () => [],
  },
});

const buildDisplayCards = (cards, loading, placeholders) => {
  if (cards && cards.length) {
    return cards.map((card, index) => ({
      title: card.title ?? `card-${index}`,
      value: card.value ?? "",
      loader: loading ? 1 : 0,
    }));
  }
  if (loading) {
    const labels =
      placeholders && placeholders.length
        ? placeholders
        : Array.from({ length: PLACEHOLDER_COUNT }, () => "");
    return labels.map((label, index) => ({
      title: label || `metric-${index}`,
      value: "",
      loader: 1,
    }));
  }
  return [];
};

const monthDisplayCards = computed(() =>
  buildDisplayCards(
    props.monthCards,
    props.monthLoading,
    props.monthPlaceholderLabels
  )
);
const yearDisplayCards = computed(() =>
  buildDisplayCards(
    props.yearCards,
    props.yearLoading,
    props.yearPlaceholderLabels
  )
);
</script>

<style scoped>
.md-snapshot-panels {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.md-snapshot-panel {
  border-radius: 12px;
}

.md-panel-header {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-color-secondary);
  margin-bottom: 0.75rem;
}

.md-empty {
  border: 1px dashed var(--surface-border);
  border-radius: 12px;
  text-align: center;
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  background: var(--surface-ground);
}
</style>
